<script context="module">
  import { onMount } from "svelte";
  import { TextField } from "../../ui/form/fields";
</script>

<script>
  export let key;
  export let id;
  export let name;
  export let hint;
  export let required;
  export let placeholder;

  let districtField;
  onMount(() => {
    /* globals algoliasearch, autocomplete */

    // Algolia keys
    var client = algoliasearch("1BCM10J5NW", "cb447c9ef841769644b09abe9d38d9e0");
    var index = client.initIndex("school_districts");

    function fromHit(hit) {
      return {
        name: hit["District Name"],
        highlightedNameHtml: hit._highlightResult["District Name"].value,
        state: hit.State,
        zip: hit.ZIP,
        city: hit.City,
        highlightedCityHtml: hit._highlightResult.City.value
      };
    }

    function htmlFromHit(hit) {
      var result = fromHit(hit);
      return (
        '<div><h4 class="district-title">' +
        result.highlightedNameHtml +
        '</h4><h5 class="district-subtitle"><span>' +
        result.highlightedCityHtml +
        "</span>," +
        result.state +
        "</h5></div>"
      );
    }

    autocomplete("#org-district-name", { hint: false }, [
      {
        source: autocomplete.sources.hits(index, { hitsPerPage: 5 }),
        displayKey: "District Name",
        templates: {
          suggestion: htmlFromHit
        }
      }
    ]).on("autocomplete:selected", function (event, suggestion, dataset) {
      const districtName = fromHit(suggestion).name;
      districtField.setValue(districtName);
      document.getElementById("org-district-name").value = districtName;
    });
  });
</script>

<TextField bind:this={districtField} {key} {id} {name} {hint} {required} {placeholder} />
